import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { track, getSessionId } from "../lib/analytics";

export default function PageTracker() {
  const loc = useLocation();
  useEffect(() => {
    getSessionId();
    // Auto page_view on every route change
    track("page_view", { path: loc.pathname });
    // Specialized event for pricing
    if (loc.pathname === "/pricing") {
      track("pricing_view", { path: loc.pathname });
    }
  }, [loc.pathname]);
  return null;
}
